import { combineReducers } from 'redux';
import {
  GET_MASTER_CONTRACTS_REQUEST,
  GET_MASTER_CONTRACTS_SUCCESS,
  GET_MASTER_CONTRACTS_FAILURE,
  MASTER_CONTRACTS_CHECK_DONE,
} from '../constants/ActionTypes';

const list = (
  state = { data: {}, isFetching: false, errorMessage: null, checkDone: false },
  action
) => {
  switch (action.type) {
    case GET_MASTER_CONTRACTS_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
        checkDone: false,
      };
    case GET_MASTER_CONTRACTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data,
      };
    case GET_MASTER_CONTRACTS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    case MASTER_CONTRACTS_CHECK_DONE:
      return { ...state, checkDone: true };
    default:
      return state;
  }
};

const masterContracts = combineReducers({
  list,
});

export default masterContracts;
